import { GatsbyImage, StaticImage } from 'gatsby-plugin-image'
import React from 'react'
import styled from 'styled-components'

const Wrap = styled.div`
    margin-top: 116px;
    @media screen and (max-width:500px) {
        margin-right: 16px;
    margin-left: 16px;
    }
`
const Title = styled.h1`
    font-weight: 700;
    font-size: 40px;
    line-height: 44px;
    text-align: center;
    width: 100%;
    color: #39394C;
    max-width: 765px;
    margin: 0 auto;
    @media screen and (max-width: 500px) {
        font-size: 30px;
    }
`
const Grid = styled.div`
    display: grid;
    grid-template-columns: repeat(3,1fr);
    gap:20px;
    align-items: center;
    margin: 130px 40px;
    @media screen and (max-width: 900px) {
        grid-template-columns: repeat(2,1fr);
        align-items: center;
        row-gap: 10rem;
    }
    @media screen and (max-width:650px) {
        grid-template-columns: repeat(1,1fr);
        row-gap: 5rem;
    }
    @media screen and (max-width:500px) {
        margin: 64px 16px;
    }
`
const GridItem = styled.div`
background: #F5F6F7;
height: 100%;
/* Blue */
border-radius: 32px;
    padding-left: 30px;
    padding-right: 30px;
    padding-top: 40px;
`
const Icon = styled.div`

`
const GridTitle = styled.h3`
font-weight: 600;
font-size: 24px;
line-height: 28px;
margin-top:60px;
color: #39394C;
`
const Paragraph = styled.p`
font-family: 'Outfit';
font-style: normal;
font-weight: 300;
font-size: 24px;
line-height: 36px;
/* or 150% */


/* Blue */

color: #39394C;

opacity: 0.6;
@media screen and (max-width:400px) {
        font-size: 16px;
    }
`
interface AgencyProps {
    agencies: any
}

const Agency: React.FC<AgencyProps> = ({agencies}) => {
    let str = ""
    if (typeof window !== 'undefined')
    {
        let location = window.location.pathname
        str = location.replace(/^\/([^\/]*).*$/, '$1')
    }
        return (
            <Wrap>
                <Title>
                {agencies.title.text}
                </Title>
                <Grid>
                    {agencies.grid.map((agen :any) =>
                       <GridItem>
                       <Icon>
                       <GatsbyImage image={agen.grid_item.document.data.img.gatsbyImageData} alt='Agency' />
                   </Icon>
                   <GridTitle>
                   {agen.grid_item.document.data.title.text}
                   </GridTitle>
                   <Paragraph>
                    {agencies.grid[0] == agen && 
                    (
                        <Paragraph>
                            {str == 'fr-fr' ? 'Plateforme e-commerce' : 'E-commerce platform '}
                        </Paragraph>
                    )
                    }
                    {agencies.grid[1] == agen && 
                    (
                        <Paragraph>
                            {str == 'fr-fr' ? 'Plateforme e-commerce' : 'E-commerce platform '}
                        </Paragraph>
                    )
                    }
                    {agencies.grid[2] == agen && 
                    (
                        <Paragraph>
                            {str == 'fr-fr' ? 'Plateforme marketing' : 'Marketing platform'}
                        </Paragraph>
                    )
                    }
                   </Paragraph>
                   <Paragraph>
                   {agen.grid_item.document.data.paragraph.text}
                   </Paragraph>
                       </GridItem>
                    )}
                 
                </Grid>
            </Wrap>
        );
}
export default Agency
